import React, { useEffect, useState } from 'react';
import PortsAutoComplete from 'components/common/PortsAutoComplete';
import _ from 'lodash';
import api from 'services';

/**
 * @param {{
 *  field: string,
 *  data: any,
 *  changeFieldsMultiple: Function,
 *  countIndex: number,
 *  required?: boolean,
 *  setHasErrors: Function,
 *  mainRegions?: boolean,
 *  withAreas?: boolean,
 *  onlyAreas?: boolean,
 *  isInBalticIndex?: boolean,
 *  placeFrom?: string,
 *  placeTo?: string,
 *  regionFrom?: string,
 *  regionTo?: string,
 *  checkRequiredMain?: boolean,
 *  name?: string,
 * }} param0 
 */
function FromTo({
    field,
    data, 
    changeFieldsMultiple, 
    countIndex,
    required = false, 
    setHasErrors = (_a, _b) => {},
    mainRegions,
    withAreas,
    onlyAreas = false,
    isInBalticIndex = false,
    placeFrom = 'placeFrom',
    placeTo = 'placeTo',
    regionFrom = 'regionFrom',
    regionTo = 'regionTo',
    checkRequiredMain = true,
    name = '',
}) {
    const [current, setCurrent] = useState(data);

    const selectPort = async (port) => {
        setCurrent(port);

        const toChange = [
            {
                index: countIndex,
                field,
                value: _.pick(port, ['_id', 'name']),
            },
        ];

        if ([regionFrom, regionTo].includes(field)) {
            toChange.push({
                index: countIndex,
                field: field === regionFrom ? placeFrom : placeTo,
                value: {},
            });
        } else {
            const main = await api.getPortMainRegion(port._id);
            toChange.push({
                index: countIndex,
                field: field === placeFrom ? regionFrom : regionTo,
                value: _.pick(main.data[0] || {}, ['_id', 'name']),
            });
        }

        changeFieldsMultiple(toChange);
    };

    useEffect(() => {
        setCurrent(data);
    }, [data]);

    useEffect(() => {
        if (required) {
            const hasError = !data || !data._id;
            if (checkRequiredMain && [regionFrom, regionTo].includes(field)) {
                setHasErrors(field, hasError);
            } else if (!checkRequiredMain) {
                setHasErrors(field, hasError);
            }
        }
    }, [current]);

    const handleChangeCustomValue = (value) => {
        changeFieldsMultiple([
            {
                index: countIndex,
                field,
                value,
            },
        ]);
    };

    return (
        <PortsAutoComplete 
            name={name}
            customValue={current ? current.name : ''}
            selectValue={selectPort}
            floatingLabelStyle={{ display: 'none' }}
            hintText={null}
            underlineStyle={{ display: 'none' }}
            inputStyle={{ fontSize: '10px' }}
            style={{ top: 'unset' }}
            menuStyle={{ width: '300px' }}
            popoverProps={{
                style: { width: '300px' },
            }}
            withAreas={withAreas}
            mainRegions={mainRegions}
            onlyAreas={onlyAreas}
            handleChangeCustomValue={handleChangeCustomValue}
            isInBalticIndex={isInBalticIndex}
        />
    );
}

export default React.memo(FromTo);



// WEBPACK FOOTER //
// ./app/components/TcIndex/RowData/FromTo.jsx